import { gql } from '@apollo/client';

export const featureNumberBlockFragment = gql`
  fragment featureNumberBlock on FeatureNumberBlock {
    __typename
    sys {
      ...sys
    }
    heading
    bodyContent {
      ...featureNumberBlockRt
    }
    media {
      ...mediaImage
    }
    primaryCta {
      ...cta
    }
    secondaryCta {
      ...cta
    }
  }

  fragment featureNumberBlockRt on FeatureNumberBlockBodyContent {
    json
    links {
      ...featureNumberBlockRtLinks
    }
  }

  fragment featureNumberBlockRtLinks on FeatureNumberBlockBodyContentLinks {
    entries {
      block {
        sys {
          ...sys
        }
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }
`;
